module.exports = __webpack_public_path__ + "img/scene-enterprise.5bf0d8dd.jpg";